import {
  Children,
  ReactElement,
  isValidElement,
  forwardRef,
  cloneElement
} from 'react';

import {
  Checkbox,
  CheckboxGroupProps as MantineCheckboxGroupProps,
  CheckboxProps
} from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { CheckboxGroupOverridesClassNames } from './Checkbox.styles';

interface CheckboxGroupProps extends MantineCheckboxGroupProps {
  disabled?: boolean;
  radius?: string;
}

const CheckboxGroup = forwardRef<HTMLDivElement, CheckboxGroupProps>(
  ({ disabled, children, classNames, ...rest }, ref) => {
    const childrenWithProps = Children.map(
      children as ReactElement<CheckboxProps>[],
      (child: ReactElement<CheckboxProps>) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...child.props,
            size: child.props.size || rest.size,
            radius: child.props.radius || rest.radius,
            disabled: disabled || child.props.disabled
          });
        }
        return child;
      }
    );

    const mergedClassNames = useMergeClassNames({
      classNames: [classNames, CheckboxGroupOverridesClassNames()]
    });

    return (
      <Checkbox.Group {...rest} ref={ref} classNames={mergedClassNames}>
        {childrenWithProps}
      </Checkbox.Group>
    );
  }
);

export { CheckboxGroup };
export type { CheckboxGroupProps };
